module.exports = __webpack_public_path__ + "media/images/emblems/Blason_ville_ch_Mex_(Vaud)-35e182bce4ced6478900b90b8daab561.svg";